// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3frjc","containerItemsCenter":"Skeleton_containerItemsCenter__3WjpK"};